import { IClientsPermissions } from '../domain/IClientsPermissions'
import { IAuthenticationRepository } from '../domain/IAuthenticationRepository'

export class GetClientsPermissions {
  constructor(private readonly authenticationRepository: IAuthenticationRepository) {}

  async execute(): Promise<IClientsPermissions> {
    return this.authenticationRepository.getClientsPermissions()
  }
}
